export const defaultcolumns = [
    {
      internVisible: true,
      dataField: 'field_001',
      caption: 'recherche.list.id',
      name: 'field_001',
      dataType: 'number',
      width: 150,
      visible: false,
      alignment: 'right',
      allowEditing: false,
      allowHeaderFiltering: false,
      allowSorting: false,
      allowFiltering: false
    },
    {
      dataField: 'cRMAddress.field_001',
      name: 'cRMAddress.field_001',
      caption: 'recherche.detail.addressId',
      dataType: 'number',
      width: 100,
      visible: true,
      allowEditing: false,
      allowHeaderFiltering: false,
      allowSorting: true,
      allowFiltering: false
    },
    {
      dataField: 'datum',
      caption: 'recherche.detail.orderdate',
      name: 'bestelldatum',
      dataType: 'date',
      width: 150,
      visible: false,
      format: 'dd.MM.yyyy',
      alignment: 'right',
      allowEditing: false,
      allowHeaderFiltering: false,
      allowSorting: true,
      allowFiltering: false
    },
    {
      dataField: 'cRMAddress.company',
      caption: 'recherche.detail.company',
      name: 'cRMAddress.company',
      dataType: 'string',
      width: 300,
      visible: true,
      allowEditing: true,
      allowHeaderFiltering: false,
      allowSorting: true,
      allowFiltering: true
    },
    {
      dataField: 'casequality',
      name: 'casequality',
      caption: 'recherche.detail.casequality',
      dataType: 'number',
      width: 80,
      visible: true,
      allowEditing: true,
      allowHeaderFiltering: false,
      allowSorting: true,
      allowFiltering: false,
      lookup: {
        dataSource: 'casequalityTypes',
        displayExpr: 'casequality',
        valueExpr: 'field_001',
        allowClearing: true
      }
    },
    {
      dataField: 'cRMAddress.profiles[0].oneLiner_en',
      name: 'cRMAddress.profiles[0].oneLiner_en',
      caption: 'recherche.detail.oneLinerEn',
      dataType: 'string',
      width: 400,
      visible: true,
      allowEditing: true,
      allowHeaderFiltering: false,
      allowFiltering: false,
      allowSorting: false,
      isProfile: true
    },
    {
      dataField: 'cRMAddress.profiles[0].description_open_en',
      name: 'cRMAddress.profiles[0].description_open_en',
      caption: 'recherche.detail.descriptionEN',
      dataType: 'string',
      width: 600,
      visible: false,
      allowEditing: true,
      allowHeaderFiltering: false,
      allowFiltering: false,
      allowSorting: false,
      isProfile: true
    },
    {
      dataField: 'cRMAddress.streetB',
      name: 'cRMAddress.streetB',
      caption: 'recherche.detail.streetB',
      dataType: 'string',
      width: 150,
      visible: false,
      allowEditing: true,
      allowHeaderFiltering: false,
      allowFiltering: true,
      allowSorting: true
    },
    {
      dataField: 'cRMAddress.zipB',
      name: 'cRMAddress.zipB',
      caption: 'recherche.detail.zipB',
      dataType: 'string',
      width: 80,
      visible: false,
      allowEditing: true,
      allowHeaderFiltering: false,
      allowFiltering: true,
      allowSorting: true
    },
    {
      dataField: 'cRMAddress.cityB',
      name: 'cRMAddress.cityB',
      caption: 'recherche.detail.cityB',
      dataType: 'string',
      width: 150,
      visible: true,
      allowEditing: true,
      allowHeaderFiltering: false,
      allowFiltering: true,
      allowSorting: true
    },
    {
      dataField: 'cRMAddress.countryBId',
      name: 'cRMAddress.countryBId',
      caption: 'recherche.detail.countryB',
      dataType: 'string',
      width: 150,
      visible: true,
      allowEditing: true,
      allowHeaderFiltering: true,
      allowFiltering: true,
      allowSorting: true,
      lookup: {
        dataSource: 'countryTypes',
        displayExpr: 'land',
        valueExpr: 'field_001',
        allowClearing: true
      }
    },
    {
      dataField: 'cRMAddress.incorporationDate',
      name: 'cRMAddress.incorporationDate',
      caption: 'recherche.detail.incorporationDate',
      visible: true,
      alignment: 'right',
      dataType: 'date',
      format: 'dd.MM.yyyy',
      width: 100,
      allowEditing: true,
      allowHeaderFiltering: false,
      allowFiltering: true,
      allowSorting: true
    },
    {
      dataField: 'cRMAddress.cRMUniFaculty.universityIDId',
      name: 'cRMAddress.cRMUniFaculty.universityIDId',
      caption: 'recherche.detail.university',
      dataType: 'number',
      width: 200,
      visible: false,
      allowEditing: true,
      allowHeaderFiltering: true,
      allowFiltering: true,
      allowSorting: true,
      lookup: {
        dataSource: 'universityTypes',
        displayExpr: 'university',
        valueExpr: 'field_001',
        allowClearing: true
      }
    },
    {
      dataField: 'cRMAddress.universityFacultyIDId',
      name: 'cRMAddress.universityFacultyIDId',
      caption: 'recherche.detail.faculty',
      dataType: 'number',
      visible: false,
      width: 200,
      allowEditing: true,
      allowHeaderFiltering: true,
      allowFiltering: true,
      allowSorting: true,
      lookup: {
        dataSource: 'getFilteredFaculties',
        displayExpr: 'departementFaculty',
        valueExpr: 'field_001'
      }
    },
    {
      dataField: 'cRMAddress.firstname',
      name: 'cRMAddress.firstname',
      caption: 'recherche.detail.firstname',
      visible: true,
      width: 150,
      allowEditing: true,
      allowHeaderFiltering: false,
      allowFiltering: true,
      allowSorting: true
    },
    {
      dataField: 'cRMAddress.lastname',
      name: 'cRMAddress.lastname',
      caption: 'recherche.detail.lastname',
      visible: true,
      width: 150,
      allowEditing: true,
      allowHeaderFiltering: false,
      allowFiltering: true,
      allowSorting: true
    },
    {
      dataField: 'cRMAddress.mobileB',
      name: 'cRMAddress.mobileB',
      caption: 'recherche.detail.mobile',
      visible: false,
      width: 150,
      allowEditing: true,
      allowHeaderFiltering: false,
      allowFiltering: true,
      allowSorting: true
    },
    {
      dataField: 'cRMAddress.phoneB',
      name: 'cRMAddress.phoneB',
      caption: 'recherche.detail.phoneB',
      visible: false,
      width: 150,
      allowEditing: true,
      allowHeaderFiltering: false,
      allowFiltering: true,
      allowSorting: true
    },
    {
      dataField: 'cRMAddress.emailB1',
      name: 'cRMAddress.emailB1',
      caption: 'recherche.detail.email',
      visible: true,
      width: 150,
      allowEditing: true,
      allowHeaderFiltering: false,
      allowFiltering: true,
      allowSorting: true,
      validationRules: [
        {
          type: 'pattern',
          message: 'Enter a valid Email',
            pattern: '^[^@]+@[^@]+\.[^@]+$' /* eslint-disable-line */
        }
      ]
    },
    {
      dataField: 'cRMAddress.emailB2',
      name: 'cRMAddress.emailB2',
      caption: 'recherche.detail.emailB2',
      visible: false,
      width: 150,
      allowEditing: true,
      allowHeaderFiltering: false,
      allowFiltering: true,
      allowSorting: true,
      validationRules: [
        {
          type: 'pattern',
          message: 'Enter a valid Email',
            pattern: '^[^@]+@[^@]+\.[^@]+$' /* eslint-disable-line */
        }
      ]
    },
    {
      dataField: 'cRMAddress.facebookB',
      name: 'cRMAddress.facebookB',
      caption: 'recherche.detail.facebookB',
      visible: false,
      width: 150,
      allowEditing: true,
      allowHeaderFiltering: false,
      allowFiltering: true,
      allowSorting: true
    },
    {
      dataField: 'cRMAddress.linkedInB',
      name: 'cRMAddress.linkedInB',
      caption: 'recherche.detail.linkedInB',
      visible: false,
      width: 150,
      allowEditing: true,
      allowHeaderFiltering: false,
      allowFiltering: true,
      allowSorting: true
    },
    {
      dataField: 'cRMAddress.twitterB',
      name: 'cRMAddress.twitterB',
      caption: 'recherche.detail.twitterB',
      visible: false,
      width: 150,
      allowEditing: true,
      allowHeaderFiltering: false,
      allowFiltering: true,
      allowSorting: true
    },
    {
      dataField: 'cRMAddress.instagramB',
      name: 'cRMAddress.instagramB',
      caption: 'recherche.detail.instagramB',
      visible: false,
      width: 150,
      allowEditing: true,
      allowHeaderFiltering: false,
      allowFiltering: true,
      allowSorting: true,
      validationRules: [
        {
          type: 'pattern',
          message: 'Enter a valid URL',
          pattern: '((http|https)://)|([A-Za-z]{2,}[.][A-Za-z]{2,})'
        }
      ]
    },
    {
      dataField: 'cRMAddress.similarwebB',
      name: 'cRMAddress.similarwebB',
      caption: 'recherche.detail.similarwebB',
      visible: false,
      width: 150,
      allowEditing: true,
      allowHeaderFiltering: false,
      allowFiltering: true,
      allowSorting: true,
      validationRules: [
        {
          type: 'pattern',
          message: 'Enter a valid URL',
          pattern: '((http|https)://)|([A-Za-z]{2,}[.][A-Za-z]{2,})'
        }
      ]
    },
    {
      dataField: 'cRMAddress.alexaB',
      name: 'cRMAddress.alexaB',
      caption: 'recherche.detail.alexaB',
      visible: false,
      width: 150,
      allowEditing: true,
      allowHeaderFiltering: false,
      allowFiltering: true,
      allowSorting: true,
      validationRules: [
        {
          type: 'pattern',
          message: 'Enter a valid URL',
          pattern: '((http|https)://)|([A-Za-z]{2,}[.][A-Za-z]{2,})'
        }
      ]
    },
    {
      dataField: 'cRMAddress.salutationId',
      name: 'cRMAddress.salutationId',
      caption: 'recherche.detail.salutationId',
      width: 150,
      visible: true,
      dataType: 'number',
      allowEditing: true,
      allowHeaderFiltering: false,
      allowFiltering: false,
      allowSorting: true,
      lookup: {
        dataSource: 'salutationTypes',
        displayExpr: 'getDisplayExpr',
        displayExprFunction: true,
        valueExpr: 'ansprechzeile_id'
      }
    },
    {
      dataField: 'cRMAddress.permalink',
      name: 'cRMAddress.permalink',
      caption: 'recherche.detail.startuplink',
      allowEditing: false,
      width: 180,
      visible: true,
      allowHeaderFiltering: false,
      allowFiltering: false,
      allowSorting: false,
      cellTemplate: 'permalink-template'
    },
    {
      dataField: 'cRMAddress.internetB',
      name: 'cRMAddress.internetB',
      caption: 'recherche.detail.internet',
      width: 150,
      visible: true,
      allowEditing: true,
      allowHeaderFiltering: false,
      allowFiltering: true,
      allowSorting: true,
      validationRules: [
        {
          type: 'pattern',
          message: 'Enter a valid URL',
          pattern: '((http|https)://)|([A-Za-z]{2,}[.][A-Za-z]{2,})'
        }
      ]
    },
    {
      dataField: 'cRMAddress.startupPhaseId',
      name: 'cRMAddress.startupPhaseId',
      caption: 'recherche.detail.startupPhase',
      width: 150,
      visible: true,
      allowEditing: true,
      allowHeaderFiltering: true,
      allowFiltering: true,
      allowSorting: true,
      lookup: {
        dataSource: 'startupPhaseTypes',
        displayExpr: 'startupphase',
        valueExpr: 'field_001',
        allowClearing: true
      }
    },
    {
      caption: 'recherche.detail.evaluations',
      dataField: 'vLABEvaluations.cRMMitarbeiter.vorname',
      cellTemplate: 'evaluation-template',
      calculateCellValue: 'calculateEvaluations',
      calculateSortValue: 'returnSortEvaluations',
      width: 300,
      allowEditing: false,
      allowSorting: false,
      allowHeaderFiltering: false,
      allowFiltering: false
    },
    {
      adminOnly: true,
      dataField: 'totalFunding',
      caption: 'recherche.detail.totalFunding',
      calculateCellValue: 'calcTotal',
      format: { style: 'currency', currency: 'CHF', useGrouping: true, minimumSignificantDigits: 3 },
      allowFiltering: false,
      allowSorting: false,
      allowEditing: false,
      width: 150,
      allowHeaderFiltering: false,
      withoutQueryField: true
    },
    {
      adminOnly: true,
      dataField: 'cRMAddress.profiles[0].cRMFundingProfileV2s.investmentsTypeId',
      caption: 'recherche.detail.fundraisingGoalLatestFunding',
      calculateCellValue: 'fundraisingGoal',
      format: { style: 'currency', currency: 'CHF', useGrouping: true, minimumSignificantDigits: 3 },
      allowFiltering: false,
      allowSorting: false,
      allowEditing: false,
      width: 150,
      visible: false,
      allowHeaderFiltering: false,
      isProfile: true
    },
    {
      adminOnly: true,
      dataField: 'closingDateLatestFunding',
      caption: 'recherche.detail.closingDateLatestFunding',
      calculateCellValue: 'latestClosingDate',
      allowFiltering: false,
      allowSorting: false,
      allowEditing: false,
      alignment: 'right',
      dataType: 'date',
      format: 'dd.MM.yyyy',
      width: 100,
      visible: false,
      allowHeaderFiltering: false,
      withoutQueryField: true
    },
    {
      adminOnly: true,
      dataField: 'stageLatestFunding',
      caption: 'recherche.detail.stageLatestFunding',
      calculateCellValue: 'latestStage',
      allowFiltering: false,
      allowSorting: false,
      allowEditing: false,
      allowHeaderFiltering: false,
      width: 100,
      visible: false,
      lookup: {
        dataSource: 'investmentStages',
        displayExpr: 'investmentsStage',
        valueExpr: 'field_001'
      },
      withoutQueryField: true
    },
    {
      dataField: 'cRMAddress.technologyId',
      caption: 'recherche.detail.technology',
      visible: false,
      width: 200,
      allowFiltering: true,
      allowSorting: true,
      allowEditing: true,
      allowHeaderFiltering: true,
      lookup: {
        dataSource: 'brancheTypes',
        displayExpr: 'brancheEn',
        valueExpr: 'field_001',
        allowClearing: true
      }
    },
    {
      caption: 'recherche.detail.sectors',
      dataField: 'cRMAddress.profiles[0].pROFILProfilJOINCategories.pROFILCategory.kategorieDE',
      cellTemplate: 'sectors-template',
      calculateCellValue: 'calculateSectors',
      width: 500,
      allowEditing: false,
      visible: false,
      allowHeaderFiltering: false,
      allowSorting: false,
      allowFiltering: false,
      isProfile: true
    },
    {
      dataField: 'cRMAddress.unispinoffId',
      caption: 'recherche.detail.unispinoff',
      visible: false,
      width: 200,
      allowFiltering: true,
      allowSorting: true,
      allowEditing: true,
      allowHeaderFiltering: true,
      lookup: {
        dataSource: 'universityTypes',
        displayExpr: 'university',
        valueExpr: 'field_001',
        allowClearing: true
      }
    },
    {
      dataField: 'supportVK',
      calculateCellValue: 'getDisplayExprVK',
      caption: 'recherche.detail.ventureKick',
      allowEditing: false,
      width: 70,
      alignment: 'center',
      visible: false,
      allowSorting: false,
      allowHeaderFiltering: false,
      allowFiltering: false,
      withoutQueryField: true
    },
    {
      dataField: 'supportVL',
      calculateCellValue: 'getDisplayExprVL',
      caption: 'recherche.detail.ventureLeaders',
      allowEditing: false,
      width: 70,
      alignment: 'center',
      visible: false,
      allowSorting: false,
      allowHeaderFiltering: false,
      allowFiltering: false,
      withoutQueryField: true
    },
    {
      dataField: 'supportT100',
      calculateCellValue: 'getDisplayExprT100',
      caption: 'recherche.detail.Top100',
      allowEditing: false,
      width: 70,
      alignment: 'center',
      visible: false,
      allowSorting: false,
      allowHeaderFiltering: false,
      allowFiltering: false,
      withoutQueryField: true
    },
    {
      dataField: 'supportIS',
      calculateCellValue: 'getDisplayExprIS',
      caption: 'recherche.detail.InnoSuisse',
      allowEditing: false,
      width: 70,
      alignment: 'center',
      visible: false,
      allowSorting: false,
      allowHeaderFiltering: false,
      allowFiltering: false,
      withoutQueryField: true
    },
    {
      dataField: 'cRMAddress.priovlabId',
      caption: 'recherche.detail.priovlabId',
      visible: false,
      width: 100,
      allowSorting: true,
      allowHeaderFiltering: true,
      allowFiltering: true,
      allowEditing: true,
      lookup: {
        dataSource: 'priovlabTypes',
        displayExpr: 'status',
        valueExpr: 'field_001',
        allowClearing: true
      }
    },
    {
      dataField: 'cRMAddress.prioXMasId',
      caption: 'recherche.detail.prioXMasId',
      visible: false,
      width: 100,
      allowSorting: true,
      allowHeaderFiltering: true,
      allowFiltering: true,
      allowEditing: true,
      lookup: {
        dataSource: 'priovlabxmasTypes',
        displayExpr: 'statusxmas',
        valueExpr: 'field_001',
        allowClearing: true
      }
    },
    {
      dataField: 'cRMAddress.vKCaseStatus',
      caption: 'recherche.detail.vKCaseStatus',
      visible: false,
      width: 150,
      allowSorting: true,
      allowHeaderFiltering: true,
      allowFiltering: true,
      allowEditing: true,
      lookup: {
        dataSource: 'vkCaseStatusTypes',
        displayExpr: 'casestatus',
        valueExpr: 'field_001',
        allowClearing: true
      }
    },
    {
      dataField: 'cRMAddress.vKacademiclinkId',
      caption: 'recherche.detail.vKacademiclink',
      visible: false,
      width: 200,
      allowSorting: true,
      allowHeaderFiltering: true,
      allowFiltering: true,
      allowEditing: true,
      lookup: {
        dataSource: 'universityTypes',
        displayExpr: 'university',
        valueExpr: 'field_001',
        allowClearing: true
      }
    },
    {
      dataField: 'cRMAddress.tradeRegisterNr',
      caption: 'recherche.detail.tradeRegisterNr',
      visible: false,
      width: 200,
      allowSorting: true,
      allowHeaderFiltering: false,
      allowFiltering: true,
      allowEditing: true
    },
    {
      dataField: 'cRMAddress.legalFormId',
      caption: 'recherche.detail.legalFormId',
      visible: false,
      width: 150,
      allowSorting: true,
      allowHeaderFiltering: true,
      allowFiltering: true,
      allowEditing: true,
      lookup: {
        dataSource: 'rechtsformTypes',
        displayExpr: 'rechtsform',
        valueExpr: 'field_001',
        allowClearing: true
      }
    },
    {
      dataField: 'cRMAddress.streetP',
      caption: 'recherche.detail.streetP',
      visible: false,
      width: 150,
      allowSorting: true,
      allowHeaderFiltering: false,
      allowFiltering: true,
      allowEditing: true
    },
    {
      dataField: 'cRMAddress.zipP',
      caption: 'recherche.detail.zipP',
      visible: false,
      width: 80,
      allowSorting: true,
      allowHeaderFiltering: false,
      allowFiltering: true,
      allowEditing: true
    },
    {
      dataField: 'cRMAddress.cityP',
      caption: 'recherche.detail.cityP',
      visible: false,
      width: 150,
      allowHeaderFiltering: false,
      allowSorting: true,
      allowFiltering: true,
      allowEditing: true
    },
    {
      dataField: 'cRMAddress.countryPId',
      caption: 'recherche.detail.countryP',
      visible: false,
      width: 200,
      allowSorting: true,
      allowHeaderFiltering: true,
      allowFiltering: true,
      allowEditing: true,
      lookup: {
        dataSource: 'countryTypes',
        displayExpr: 'land',
        valueExpr: 'field_001'
      }
    },
    {
      dataField: 'cRMAddress.mobileP',
      caption: 'recherche.detail.mobileP',
      visible: false,
      width: 150,
      allowSorting: true,
      allowHeaderFiltering: false,
      allowFiltering: true,
      allowEditing: true
    },
    {
      dataField: 'cRMAddress.phoneP',
      caption: 'recherche.detail.phoneP',
      visible: false,
      width: 150,
      allowSorting: true,
      allowHeaderFiltering: false,
      allowFiltering: true,
      allowEditing: true
    },
    {
      dataField: 'cRMAddress.emailP1',
      caption: 'recherche.detail.emailP1',
      visible: false,
      width: 150,
      allowSorting: true,
      allowHeaderFiltering: false,
      allowFiltering: true,
      allowEditing: true,
      validationRules: [
        {
          type: 'pattern',
          message: 'Enter a valid Email',
            pattern: '^[^@]+@[^@]+\.[^@]+$' /* eslint-disable-line */
        }
      ]
    },
    {
      dataField: 'cRMAddress.emailP2',
      caption: 'recherche.detail.emailP2',
      visible: false,
      width: 150,
      allowSorting: true,
      allowHeaderFiltering: false,
      allowFiltering: true,
      allowEditing: true,
      validationRules: [
        {
          type: 'pattern',
          message: 'Enter a valid Email',
          pattern: '^[^@]+@[^@]+\.[^@]+$' /* eslint-disable-line */
        }
      ]
    },
    {
      dataField: 'cRMAddress.facebookP',
      caption: 'recherche.detail.facebookP',
      visible: false,
      width: 150,
      allowSorting: true,
      allowHeaderFiltering: false,
      allowFiltering: true,
      allowEditing: true
    },
    {
      dataField: 'cRMAddress.linkedInP',
      caption: 'recherche.detail.linkedInP',
      visible: false,
      width: 150,
      allowSorting: true,
      allowHeaderFiltering: false,
      allowFiltering: true,
      allowEditing: true
    },
    {
      dataField: 'cRMAddress.twitterP',
      caption: 'recherche.detail.twitterP',
      visible: false,
      width: 150,
      allowSorting: true,
      allowHeaderFiltering: false,
      allowFiltering: true,
      allowEditing: true,
      validationRules: [
        {
          type: 'pattern',
          message: 'Enter a valid URL',
          pattern: '((http|https)://)|([A-Za-z]{2,}[.][A-Za-z]{2,})'
        }
      ]
    },
    {
      dataField: 'cRMAddress.birthday',
      caption: 'recherche.detail.birthday',
      dataType: 'date',
      format: 'dd.MM.yyyy',
      visible: false,
      alignment: 'right',
      width: 100,
      allowSorting: true,
      allowHeaderFiltering: false,
      allowFiltering: true,
      allowEditing: true
    },
    {
      dataField: 'cRMAddress.languageId',
      caption: 'recherche.detail.languageId',
      visible: false,
      width: 100,
      allowSorting: true,
      allowHeaderFiltering: true,
      allowFiltering: true,
      allowEditing: true,
      lookup: {
        dataSource: 'languagesTypes',
        displayExpr: 'spracheEN',
        valueExpr: 'field_001'
      }
    },
    {
      dataField: 'cRMAddress.educationId',
      caption: 'recherche.detail.educationId',
      visible: false,
      width: 150,
      allowSorting: true,
      allowHeaderFiltering: true,
      allowFiltering: true,
      allowEditing: true,
      lookup: {
        dataSource: 'educationTypes',
        displayExpr: 'education',
        valueExpr: 'field_001',
        allowClearing: true
      }
    },
    {
      dataField: 'cRMAddress.position',
      caption: 'recherche.detail.position',
      visible: false,
      width: 180,
      allowSorting: true,
      allowHeaderFiltering: false,
      allowFiltering: true,
      allowEditing: true
    },
    {
      dataField: 'cRMAddress.kantonId',
      caption: 'recherche.detail.kantonId',
      visible: false,
      width: 150,
      allowSorting: true,
      allowHeaderFiltering: true,
      allowFiltering: true,
      allowEditing: true,
      lookup: {
        dataSource: 'cantonTypes',
        displayExpr: 'kantonEN',
        valueExpr: 'field_001',
        allowClearing: true
      }
    },
    {
      dataField: 'cRMAddress.sUTkrTradeRegUID',
      caption: 'recherche.detail.sutkruid',
      visible: false,
      width: 100,
      allowSorting: true,
      allowHeaderFiltering: false,
      allowFiltering: true,
      allowEditing: true
    },
    {
      adminOnly: true,
      dataField: 'cRMAddress.profiles[0].pEOPLEFemaleFounders',
      caption: 'recherche.detail.peoplefemalefounders',
      visible: false,
      width: 150,
      allowHeaderFiltering: false,
      allowFiltering: false,
      allowSorting: false,
      allowEditing: true,
      isProfile: true
    },
    {
      adminOnly: true,
      dataField: 'cRMAddress.profiles[0].pEOPLEMaleFounders',
      caption: 'recherche.detail.peoplemalefounders',
      visible: false,
      width: 150,
      allowHeaderFiltering: false,
      allowFiltering: false,
      allowSorting: false,
      allowEditing: true,
      isProfile: true
    },
    {
      adminOnly: true,
      dataField: 'cRMAddress.profiles[0].peopleEPFLFac',
      caption: 'recherche.detail.peopleEPFLFac',
      visible: false,
      width: 150,
      allowHeaderFiltering: false,
      allowFiltering: false,
      allowSorting: false,
      allowEditing: true,
      isProfile: true
    },
    {
      adminOnly: true,
      dataField: 'cRMAddress.profiles[0].peopleEPFLLab',
      caption: 'recherche.detail.peopleEPFLLab',
      visible: false,
      width: 150,
      allowHeaderFiltering: false,
      allowFiltering: false,
      allowSorting: false,
      allowEditing: true,
      isProfile: true
    },
    {
      adminOnly: true,
      dataField: 'cRMAddress.profiles[0].peopleEPFLProf',
      caption: 'recherche.detail.peopleEPFLProf',
      visible: false,
      width: 150,
      allowHeaderFiltering: false,
      allowFiltering: false,
      allowSorting: false,
      allowEditing: true,
      isProfile: true
    },
    {
      adminOnly: true,
      dataField: 'cRMAddress.profiles[0].totalEmployee',
      caption: 'recherche.detail.totalEmployee',
      visible: false,
      width: 150,
      allowHeaderFiltering: false,
      allowFiltering: false,
      allowSorting: false,
      allowEditing: false,
      isProfile: true
    },
    {
      adminOnly: true,
      dataField: 'cRMAddress.profiles[0].changeDate',
      caption: 'recherche.detail.changeDate',
      dataType: 'date',
      format: 'dd.MM.yyyy',
      alignment: 'right',
      visible: false,
      allowEditing: false,
      width: 150,
      allowHeaderFiltering: false,
      allowFiltering: false,
      allowSorting: false,
      isProfile: true
    },
    {
      adminOnly: true,
      dataField: 'cRMAddress.profiles[0].turnOver',
      caption: 'recherche.detail.turnover',
      visible: false,
      allowEditing: false,
      width: 150,
      allowHeaderFiltering: false,
      allowFiltering: false,
      allowSorting: false,
      isProfile: true
    },
    {
      adminOnly: true,
      dataField: 'cRMAddress.profiles[0].ownedCopyrights',
      caption: 'recherche.detail.ownedCopyrights',
      visible: false,
      allowEditing: false,
      width: 150,
      allowHeaderFiltering: false,
      allowFiltering: false,
      allowSorting: false,
      isProfile: true
    },
    {
      adminOnly: true,
      dataField: 'cRMAddress.profiles[0].ownedTrademarks',
      caption: 'recherche.detail.ownedTrademarks',
      visible: false,
      allowEditing: false,
      width: 150,
      allowHeaderFiltering: false,
      allowFiltering: false,
      allowSorting: false,
      isProfile: true
    },
    {
      adminOnly: true,
      dataField: 'cRMAddress.profiles[0].pendingPatents',
      caption: 'recherche.detail.pendingPatents',
      visible: false,
      allowEditing: false,
      width: 150,
      allowHeaderFiltering: false,
      allowFiltering: false,
      allowSorting: false,
      isProfile: true
    },
    {
      adminOnly: true,
      dataField: 'cRMAddress.profiles[0].grantedPatents',
      caption: 'recherche.detail.grantedPatents',
      visible: false,
      allowEditing: false,
      width: 150,
      allowHeaderFiltering: false,
      allowFiltering: false,
      allowSorting: false,
      isProfile: true
    },
    {
      adminOnly: true,
      caption: 'recherche.detail.reportingGroups',
      dataField: 'cRMAddress.profiles[0].pROFILProfilJOINReportingGroups.pROFILReportingGroup.reportingGroups',
      cellTemplate: 'reporting-template',
      calculateCellValue: 'calculateReportinggroups',
      width: 300,
      allowEditing: false,
      visible: false,
      allowHeaderFiltering: false,
      allowSorting: false,
      allowFiltering: false,
      isProfile: true
    },
    {
      internVisible: true,
      internCode: 'joinRolles',
      caption: 'intern Roles',
      dataField: 'cRMAddress.cRMAdresseJOINRolles.rolle_id',
      visible: false,
      allowEditing: false,
      allowHeaderFiltering: false,
      allowFiltering: false,
      allowSorting: false
    },
    {
      internVisible: false,
      internCode: 'unterstuetzung',
      caption: 'intern Support',
      dataField: 'cRMAddress.profiles[0].pROFILUntersttzungszuweisungs.untersttzungId',
      visible: false,
      allowEditing: false,
      allowHeaderFiltering: false,
      allowFiltering: false,
      allowSorting: false
    },
    {
      internVisible: false,
      internCode: 'investmenStage',
      caption: 'intern invesetmenstage',
      dataField: 'cRMAddress.profiles[0].cRMFundingProfileV2s.investmentsStage',
      visible: false,
      allowEditing: false,
      allowHeaderFiltering: false,
      allowFiltering: false,
      allowSorting: false
    },
    {
      internVisible: false,
      internCode: 'fundingStatusId',
      caption: 'intern statusId',
      dataField: 'cRMAddress.profiles[0].cRMFundingProfileV2s.statusId',
      visible: false,
      allowEditing: false,
      allowHeaderFiltering: false,
      allowFiltering: false,
      allowSorting: false
    },
    {
      internVisible: false,
      internCode: 'fundingMoneyInCHF',
      caption: 'intern moneyInCHF',
      dataField: 'cRMAddress.profiles[0].cRMFundingProfileV2s.moneyinCHF',
      visible: false,
      allowEditing: false,
      allowHeaderFiltering: false,
      allowFiltering: false,
      allowSorting: false
    },
    {
      internVisible: false,
      internCode: 'fundingClosingDate',
      caption: 'intern funding Closingdate',
      dataField: 'cRMAddress.profiles[0].cRMFundingProfileV2s.closingdate',
      visible: false,
      allowEditing: false,
      allowHeaderFiltering: false,
      allowFiltering: false,
      allowSorting: false
    },
    {
      internVisible: false,
      internCode: 'evaluationCasequality',
      caption: 'intern evaluation casequality',
      dataField: 'vLABEvaluations.sEMINARCasequality.casequality',
      visible: false,
      allowEditing: false,
      allowHeaderFiltering: false,
      allowFiltering: false,
      allowSorting: false
    },
    {
      internVisible: true,
      internCode: 'profileType',
      caption: 'intern profile type',
      dataField: 'cRMAddress.profiles[0].profiltypId',
      visible: false,
      allowEditing: false,
      allowHeaderFiltering: false,
      allowFiltering: false,
      allowSorting: false
    },
    {
      internVisible: true,
      internCode: 'profileAdressId',
      caption: 'intern profile crmAdressId',
      dataField: 'cRMAddress.profiles[0].cRM_Adress_id',
      visible: false,
      allowEditing: false,
      allowHeaderFiltering: false,
      allowFiltering: false,
      allowSorting: false
    }
  ]
